import React from 'react';
import './FAQ.css'
// import plus from '../../Assets/Plus.svg'
// import minus from '../../Assets/Minus.svg'
import { useState } from 'react';

const FAQ = (props) => {

    const [open, setOpen] = useState(false);

    const toggleFAQ = () => {
        setOpen(!open);
    };


    return ( 
        <div className={`FAQCard ${open ? 'open' : ''}`} onClick={toggleFAQ}>
            <p className='Question'>{props.question}</p>
            <div className='QIcon'></div>
            <p className='Answer'>{props.answer}</p>
        </div>
     );
}
 
export default FAQ;